import styled from "styled-components";

const Container = styled.section`
  max-width: 1024px;
  margin: auto;

  padding: 2rem 0;
  line-height: 1.4;
`;

export default Container;
